/**
 * KT Custom Accordion Functionality
 * Specifically for the product description accordions added via HTML.
 */

(function() {
  function initKtAccordions() {
    // 1. Handle KT-specific accordions (kt-accordion-wrapper)
    const ktWrappers = document.querySelectorAll('.kt-accordion-wrapper');
    ktWrappers.forEach(wrapper => {
      if (wrapper.dataset.initialized) return;
      wrapper.dataset.initialized = 'true';

      const items = wrapper.querySelectorAll('.kt-acc-item');
      items.forEach((item) => {
        const btn = item.querySelector('.kt-acc-btn');
        if (!btn) return;

        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const isActive = item.classList.contains('active');
          if (isActive) {
            item.classList.remove('active');
          } else {
            item.classList.add('active');
          }
        });
      });
    });

    // 2. Handle standard accordions (User provided .accordion class)
    const stdWrappers = document.querySelectorAll('.accordion');
    stdWrappers.forEach(wrapper => {
      if (wrapper.dataset.initialized) return;
      wrapper.dataset.initialized = 'true';

      const items = wrapper.querySelectorAll('.accordion-item');
      items.forEach((item) => {
        const header = item.querySelector('.accordion-header');
        if (!header) return;

        header.addEventListener('click', (e) => {
          e.preventDefault();
          const isActive = item.classList.contains('active');
          
          // Close other items in the same accordion for cleaner UX
          wrapper.querySelectorAll('.accordion-item').forEach(i => {
            if (i !== item) i.classList.remove('active');
          });
          
          if (isActive) {
            item.classList.remove('active');
          } else {
            item.classList.add('active');
          }
        });
      });
      
      // Optionally open the first item by default if none are active
      const activeItem = wrapper.querySelector('.accordion-item.active');
      if (!activeItem) {
        const firstItem = wrapper.querySelector('.accordion-item');
        if (firstItem) firstItem.classList.add('active');
      }
    });

    // 3. Handle KT MEN Hair Accordion (.ktm-hair-accordion)
    const ktmWrappers = document.querySelectorAll('.ktm-hair-accordion');
    ktmWrappers.forEach(wrapper => {
      if (wrapper.dataset.initialized) return;
      wrapper.dataset.initialized = 'true';

      const items = wrapper.querySelectorAll('.ktm-hair-item');
      items.forEach((item, index) => {
        const header = item.querySelector('.ktm-hair-header');
        if (!header) return;

        // Open the first item by default
        if (index === 0) item.classList.add('active');

        header.addEventListener('click', (e) => {
          e.preventDefault();
          const isActive = item.classList.contains('active');
          
          if (isActive) {
            item.classList.remove('active');
          } else {
            // Close others
            items.forEach(i => i.classList.remove('active'));
            item.classList.add('active');
          }
        });
      });
    });
  }

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKtAccordions);
  } else {
    initKtAccordions();
  }

  // Re-initialize when Shopify section loads in editor
  document.addEventListener('shopify:section:load', initKtAccordions);
})();
